import Button from '@ui/Button'
import {ROUTES } from '@/constants'

// "Everything you need to spark participation" bento grid.
// Content copied verbatim from the reference. Illustrations (avatar
// stacks, chat bubbles, charts, tool-icon row) are recreated with
// plain CSS/SVG + FontAwesome brand icons — no image assets needed.
export default function SparkParticipation() {
  return (
    <section id="spark-participation" className="section-py bg-linear-gradient-light" aria-labelledby="spark-heading">
      <div className="container">
        <div className="section-header" data-aos="fade-up">         
           <span className="process-eyebrow">REAL STORIES, REAL IMPACT</span>
          <h2 id="spark-heading">Here’s picking up a few projects from our pandora box</h2>
          <p className="section-subheading">
            Our expertise has enabled companies to further enhance efficiencies in their business outcomes and scale newer heights of success. We have been consistently doing this for various industries over the past 16+ years.
          </p>
        </div>

        <div className="spark-grid">
          {/* A — tall blue card */}
          <div className="spark-card spark-card--a" data-aos="fade-up" data-aos-delay="30">
            <img src="/assets/images/stories-home/grid-india-website.png" alt="Grid India" />
            <h3 className="spark-title">GIGW Compliant Government Portal</h3>
            <p className="spark-desc">
              In the GRID India portal, we not only incorporated fresh design, but also ensured it met all the levels of GIGW/ STQC as well as VAPT compliances. It has a full fledged CMS portal to manage the content. The entire software is hosted behind a managed firewall.
            </p>
          </div>

          {/* B — avatar stack */}
          <div className="spark-card spark-card--b" data-aos="fade-up" data-aos-delay="60">
            <img src="/assets/images/stories-home/inclinic.png" alt="inclinic"  />
            <h3 className="spark-title">Workflow Automation for Clinics</h3>
            <p className="spark-desc">This cloud-based portal automates the complete process of Holter & ECG uploading as well as reporting.</p>
          </div>

          {/* D — bar chart */}
          <div className="spark-card spark-card--d" data-aos="fade-up" data-aos-delay="90">
            <div>
              <img src="/assets/images/stories-home/india-exports.png" alt="India Exports" />
            </div>
            <h3 className="spark-title">ERP For Textile Exports</h3>
            <p className="spark-desc">This is an internal business process automation tool tailored for Ishwar Exports, based in Mumbai.</p>
          </div>

          {/* C — trending notification */}
          <div className="spark-card spark-card--c" data-aos="fade-up" data-aos-delay="120">
          <img src="/assets/images/stories-home/delp1.jpg" alt="Grid India" />
            <h3 className="spark-title">National UJALA Dashboard</h3>
            <p className="spark-desc">It was one of the first digitalization initiative by the Government of India.</p>
          </div>

          {/* F — line chart */}
          <div className="spark-card spark-card--f" data-aos="fade-up" data-aos-delay="150">
            <div style={{display:'flex',gap:'0.5rem'}}>
               <img src="/assets/images/stories-home/praapti-website.png" alt="Praapti" />
            </div>
            <h3 className="spark-title">PRAAPTI Portal</h3>
            <p className="spark-desc">This is an initiative by the Ministry of Power and managed by PFC Consulting Ltd. We engineered this portal and transformed it into a revenue generating product for the client.</p>
          </div>

          {/* E — chat reply */}
          <div className="spark-card spark-card--e" data-aos="fade-up" data-aos-delay="180">
            <img src="/assets/images/stories-home/mediangels_new.jpg" alt="Medi Angle" />
            <h3 className="spark-title">Online Health Platform</h3>
            <p className="spark-desc">This was one of India's first online health platform by the brand name MediAngels.</p>
          </div>

          {/* G — creator stack icon row */}
          <div className="spark-card spark-card--g" data-aos="fade-up" data-aos-delay="210">
            <img src="/assets/images/stories-home/snehamumbai-ngo-website.png" alt="Sneha Mumbai" />
            <h3 className="spark-title">Snehamumbai Website</h3>
            <p className="spark-desc">A Non-Profit organisation based in Mumbai, we have been providing our services to them since more than a decade.</p>
          </div>
        </div>
      </div>
       <div className="wcs-actions" >
            <Button href={ROUTES.OUR_WORK} variant="primary" icon="fa-arrow-right" iconPos="right" data-aos="fade-up">
              Read more Stories
            </Button>                      
      </div>
    </section>
  )
}